module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/50k-active-873d681243d72bfe6c25b2c42d7db6ce.png";